import { environment } from '../../../environments/environment';

export enum LogLevel {
  Debug = 0,
  Info = 1,
  Warn = 2,
  Error = 3,
  Off = 4,
}

export const defaultLogLevel: LogLevel = environment.production ? LogLevel.Error : LogLevel.Debug;
